import { RefObject, useEffect, useRef } from 'react'

/**
 * Returns a ref to attach to a trigger element. When `active` flips from
 * true back to false, focus is restored to that element — used for
 * trigger-button -> confirm-row swaps where the trigger unmounts and the
 * browser would otherwise drop focus to <body>.
 */
export function useFocusReturn<T extends HTMLElement>(active: boolean): RefObject<T> {
  const ref = useRef<T>(null)
  const wasActive = useRef(false)

  useEffect(() => {
    if (active) {
      wasActive.current = true
    } else if (wasActive.current) {
      wasActive.current = false
      ref.current?.focus()
    }
  }, [active])

  return ref
}
